import React from 'react';
import { motion } from 'framer-motion';
import { benefits } from '../data/content';
import { Sparkle } from './Sparkle';
export function Benefits() {
  return <section id="vorteile" className="relative w-full bg-cream px-4 py-10 sm:px-6 sm:py-12" data-id="element-41" data-mp="9d8rjc88uebp">
      <span aria-hidden="true" className="gold-glitter-layer-static" data-id="element-42" data-mp="4icntetna2ir" />
      <span aria-hidden="true" className="gold-glitter-extra" data-id="element-43" data-mp="3vpxmjz1li9g7" />
      <div className="relative z-10 mx-auto max-w-[1300px]" data-id="element-44" data-mp="3qs5i65jrkuv4">
        <div className="text-center" data-id="element-45" data-mp="3qpjdcdo9ctgl">
          <span className="mb-4 block text-xs font-semibold uppercase tracking-[0.25em] text-hot-500" data-id="element-46" data-mp="3mpiwynhlm86w">
            Deine Vorteile
          </span>
          <h2 className="font-heading text-3xl font-extrabold uppercase leading-tight text-neutral-900 sm:text-4xl" data-id="element-47" data-mp="3hr7pgjes09ru">
            Was macht die Hot Sales Girls Academy{' '}
            <span className="relative inline-block text-hot-500" data-id="element-48" data-mp="1fyjiq02xb47b">
              aus
              <Sparkle className="animate-sparkle-delayed -right-7 top-1/2 h-6 w-6 -translate-y-1/2 sm:-right-9 sm:h-8 sm:w-8" data-id="element-49" data-mp="1b087bkwzclmz" />
            </span>
          </h2>
        </div>

        <ul className="mt-8 grid gap-5 sm:grid-cols-2 lg:auto-rows-fr" data-id="element-50" data-mp="6st4dplwztt5">
          {benefits.map((benefit, i) => <motion.li key={benefit.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.4,
          delay: i * 0.08
        }} className="flex flex-col items-stretch gap-0 overflow-hidden rounded-3xl border border-hot-100 bg-hot-50 shadow-xl lg:flex-row lg:items-stretch" data-id="element-51" data-mp="3oyxpzubo1kio" data-mpi={i}>
              <div className="flex flex-1 flex-col justify-center px-5 py-3 sm:px-6 sm:py-5 lg:p-7" data-id="element-52" data-mp="brmauy2sakjt">
                <h3 className="font-heading text-lg font-bold text-neutral-900" data-id="element-53" data-mp="gp4nozjx9jx3">{benefit.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-neutral-600" data-id="element-54" data-mp="14f8pr2hgpblz">{benefit.text}</p>
              </div>
              <img src={benefit.image} alt={benefit.imageAlt} style={{
            objectPosition: benefit.imagePosition ?? 'center top'
          }} className="aspect-[4/3] w-full shrink-0 rounded-b-3xl rounded-t-none object-cover sm:aspect-square lg:h-auto lg:w-56 lg:self-center lg:rounded-2xl xl:w-64" data-id="element-55" data-mp="19935xvxuz8gb" />
            </motion.li>)}
        </ul>
      </div>
    </section>;
}